module.exports = __webpack_public_path__ + "img/bg-02.0569d564.png";